import { call, put, takeLatest } from "redux-saga/effects";
import { fetchUserInfoAction } from "./userInfoSlice";
import { getUserInfo } from "../address/data4homeAPI";
import {
  rememberActiveTenant,
  setActiveTenant,
} from "../activeTenant/activeTenantSlice";

function pickActiveTenantId(tenants: { tenantId: string }[]): string | null {
  return tenants[0]?.tenantId ?? null;
}

function* fetchUserInfo(action: any): any {
  try {
    yield put(fetchUserInfoAction.pending());
    const userInfo: any = yield call(getUserInfo);
    yield put(fetchUserInfoAction.fulfilled(userInfo));
    const tenantId = pickActiveTenantId(userInfo.tenants ?? []);
    rememberActiveTenant(tenantId);
    yield put(setActiveTenant(tenantId));
  } catch (exception: any) {
    yield put(fetchUserInfoAction.rejected(exception.message));
  }
}

function* adressSaga() {
  yield takeLatest(fetchUserInfoAction, fetchUserInfo);
}

export default adressSaga;
